<template>
  <d-container
    fluid
    class="main-content-container px-0 px-md-4">
    <!-- Page Header -->
    <div class="container-md">
      <d-row
        no-gutters
        class="page-header py-4">
        <d-col
          cols="14"
          md="4"
          class="text-left mb-md-4">
          <span class="text-uppercase page-subtitle">Strona główna</span>
          <h3 class="page-title">Witaj w Skład Karmy CRM</h3>
        </d-col>

        <d-col
          cols="12"
          md="8"
          class="mr-0 ml-0 pt-3 text-center text-md-right">
          <d-button
            v-if="isWorker"
            theme="primary"
            @click.prevent="$router.push('/klienci/nowy')"
            class="mr-3">
            <i class="material-icons">add</i>
            Dodaj klienta
          </d-button>
          <d-button
            v-if="isWorker"
            theme="success"
            @click.prevent="$router.push('/zamowienia/nowy')">
            <i class="material-icons">add</i>
            Dodaj zamówienie
          </d-button>
        </d-col>
      </d-row>
      <d-row
        class="d-flex flex-wrap justify-content-between mb-3 mt-1 mr-0 ml-0 mt-lg-5">
        <d-card
          class="text-center pl-0 pr-0 mb-4 dashboard-card">
            <d-card-header class="h5"><span>Obroty z tego miesiąca</span></d-card-header>
            <d-card-body
              class="text-primary h3">
              {{ roundProperly(stats.turnover_current_month) }} zł
            </d-card-body>
        </d-card>
        <d-card
          class="text-center pl-0 pr-0 mb-4 dashboard-card">
            <d-card-header class="h5"><span>Obroty z poprzedniego miesiąca</span></d-card-header>
            <d-card-body
              class="text-primary h3">
              {{ roundProperly(stats.turnover_prev_month) }} zł
            </d-card-body>
        </d-card>
        <d-card
          class="text-center pl-0 pr-0 mb-4 dashboard-card">
          <d-card-header class="h5"><span>Zadłużeni klienci</span></d-card-header>
          <d-card-body
            :class="{
              'text-success': stats.customers_with_debt_count === 0,
              'text-danger': stats.customers_with_debt_count > 0,
              'h3': true
            }">
            <p>{{ stats.customers_with_debt_count }}</p>
            <d-button
              theme="primary"
              @click.prevent="showClientsInDebt">
              Pokaż klientów
            </d-button>
          </d-card-body>
        </d-card>
      </d-row>
      <d-row
        class="pt-5">
        <d-col
          sm="12"
          class="text-left">
          <h4 class="page-title">Miesięczne cele KPI</h4>
          <span class="page-subtitle">Statystyki przedstawione poniżej są szacunkowe i nie uwzględniają korekt</span>
        </d-col>
      </d-row>
      <d-row
        :style="stats.kpi.length > 2 ? 'justify-content: space-between;' : ''"
        class="d-flex flex-wrap justify-content-between my-3 mt-1 mx-0">
        <d-card
          v-for="(goal, index) of stats.kpi"
          :key="'goal-item-' + index"
          class="mb-4 px-0 text-center dashboard-kpi-card">
          <d-card-header class="h5">
            <span>{{ getPeriodFormatted(goal.month, goal.year) }}</span>
          </d-card-header>
          <d-card-body class="h2">
            <p
              :class="{
                'text-success': goal.percent >= 95,
                'text-danger': goal.percent < 95
              }">
              {{ goal.percent }} %
            </p>
            <small style="font-size: 16px;">cel: {{ goal.amount }} zł</small>
          </d-card-body>
        </d-card>
      </d-row>
    </div>
    <clients-in-debt-popup />
  </d-container>
</template>

<script>
import ClientsInDebtPopup from './../components/popups/ClientsInDebtPopup.vue';
import CustomDecimals from './../utils/CustomDecimals.js';
import CalendarUtils from './../utils/CalendarUtils';

export default {
  name: 'dashboard',
  components: {
    'clients-in-debt-popup': ClientsInDebtPopup
  },
  data() {
    return {
      stats: {
        turnover_current_month: '',
        turnover_prev_month: '',
        customers_with_debt_count: '',
        kpi: []
      },
      loaded: false,
      loadError: false
    };
  },
  computed: {
    isWorker () {
      return this.$store.getters['getUserType'] === 'WORKER';
    }
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      this.$http.get('/api/dashboard/stats', {}, {
        responseType: 'text'
      }).then((response) => {
        this.stats = response.data;
        this.loaded = true;
      }).catch(() => {
        this.loaded = true;
      });
    },
    showClientsInDebt () {
      this.$bus.$emit('show-clients-in-debt-popup');
    },
    roundProperly (value, decimals = 2) {
      return CustomDecimals.roundProperly(value, decimals);
    },
    getPeriodFormatted (month, year) {
      return CalendarUtils.getMonthName(month) + ' ' + year;
    }
  }
};
</script>

<style lang="scss" scoped>
.dashboard-kpi-card {
  width: calc(100% / 2 - 15px);
}

@media screen and (max-width: 860px) {
  .dashboard-kpi-card {
    width: 100%;
  }
}

</style>
